module.exports = __webpack_public_path__ + "static/media/hw_he_29.46c09f00.flv";